var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNavSurveys = function SvgIconNavSurveys(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.299,
    height: 96.327,
    viewBox: "0 0 83.299 96.327",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-490.756 -413.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.522,
    height: 71.117,
    rx: 3.022,
    transform: "translate(492.904 426.926)",
    strokeWidth: 4.295,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.325,425.661v4.578h49.088v-4.578H531.991v-7.895h-9.98v7.895Z",
    transform: "translate(-2.205 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.262,429.665H545.99c-.339-7.665-8.373-13.8-18.24-13.8s-17.9,6.133-18.24,13.8h-2.273a1.153,1.153,0,0,0-1.15,1.15v9.143a1.153,1.153,0,0,0,1.15,1.149h41.024a1.152,1.152,0,0,0,1.149-1.149v-9.143A1.153,1.153,0,0,0,548.262,429.665ZM527.75,427.5a3.333,3.333,0,1,1,3.332-3.333A3.333,3.333,0,0,1,527.75,427.5Z",
    transform: "translate(-3.085 -1.994)",
    fill: "#11526a"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 20.747,
    transform: "translate(504.176 451.91)",
    strokeWidth: 4.295,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 15.135,
    transform: "translate(531.383 451.91)",
    strokeWidth: 4.295,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 38.09,
    transform: "translate(504.176 461.592)",
    strokeWidth: 4.295,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 38.09,
    transform: "translate(504.176 471.273)",
    strokeWidth: 4.295,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 38.09,
    transform: "translate(504.176 482.496)",
    strokeWidth: 4.295,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(523.765 448.296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.2,534.344l-9.151,3.165.4-9.751Z",
    transform: "translate(-533.394 -476.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.194,522.71l20.475-7.195,28.959-38.459c1.77-2.352.7-6.142-2.382-8.465l-8.044-6.057c-3.086-2.323-7.023-2.3-8.794.051L534.45,501.044Z",
    transform: "translate(-533.194 -460.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 19.22,
    y2: 14.472,
    transform: "translate(1.256 40.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 19.22,
    y2: 14.472,
    transform: "translate(25.219 8.413)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527.368 453.729)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themed-fill",
    d: "M545.551,528.618l-6.926,3.359,1.243-7.638Z",
    transform: "translate(-538.067 -481.107)",
    fill: "#3393b9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "themed-stroke",
    d: "M537.9,519.51l15.508-7.6L578.1,479.112a4.545,4.545,0,0,0-.9-6.364l-5.226-3.935a4.544,4.544,0,0,0-6.364.9L540.919,502.5Z",
    transform: "translate(-537.897 -467.899)",
    fill: "none",
    stroke: "#3393b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.649
  }), /*#__PURE__*/React.createElement("line", {
    className: "themed-stroke",
    x2: 12.486,
    y2: 9.402,
    transform: "translate(3.022 34.605)",
    strokeWidth: 2.649,
    stroke: "#3393b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    className: "themed-stroke",
    x2: 12.486,
    y2: 9.402,
    transform: "translate(23.454 7.469)",
    strokeWidth: 2.649,
    stroke: "#3393b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.12 453.334)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.486,
    y1: 9.402,
    transform: "translate(0 7.469)",
    fill: "#7b967d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "themed-fill",
    d: "M583.451,472.233l-5.226-3.935a4.545,4.545,0,0,0-6.364.9l-4.26,5.658,12.486,9.4,4.26-5.658A4.545,4.545,0,0,0,583.451,472.233Z",
    transform: "translate(-567.601 -467.384)",
    fill: "#3393b9"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNavSurveys, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nav-surveys.9b4163ff.svg";
export { ForwardRef as ReactComponent };